/**
 * 下拉选择预设配置
 *  COMPARE
 *  GENDER
 *  TIME_POINT
 *  TIME_POINT_SIMPLE
 *  LOGIC
 *  SESSION_TYPE
 *  AGE
 *  EDUCATION
 *  TIME_RANG_A
 */
import i18n from 'src/i18n';

// 错误状态
const ERROR = [
  {
    text: 'type不可以设置为空',
    value: 0,
  },
];

// 数学比较
const COMPARE = [
  {
    text: i18n.t('是'),
    value: '==',
  },
  {
    text: i18n.t('不是'),
    value: '!=',
  },
  {
    text: i18n.t('大于'),
    value: '>',
  },
  {
    text: i18n.t('小于'),
    value: '<',
  },
  {
    text: i18n.t('大于等于'),
    value: '>=',
  },
  {
    text: i18n.t('小于等于'),
    value: '<=',
  },
  {
    text: i18n.t('之间'),
    value: 'between',
  },
];

// 简易版时间点
// 这里按照交互要求，为了客户容易理解，将之间改为了是
const TIME_POINT_SIMPLE = [
  {
    text: i18n.t('是'),
    value: '==',
  },
  {
    text: i18n.t('早于'),
    value: '<',
  },
  {
    text: i18n.t('晚于'),
    value: '>',
  },
];

// 逻辑比较
const LOGIC = [
  {
    text: i18n.t('是'),
    value: '==',
  },
  {
    text: i18n.t('不是'),
    value: '!=',
  },
  {
    text: i18n.t('包含'), // 字符串类型为 contains
    value: 'arrayInclude',
  },
  {
    text: i18n.t('不包含'), // 字符串类型为 !contains
    value: '!arrayInclude',
  },
];
// 学历的逻辑
const EDUCATION_LOGIC = [
  {
    text: i18n.t('是'),
    value: '==',
  },
  {
    text: i18n.t('不是'),
    value: '!=',
  },
];
// 时间点
const TIME_POINT = [
  {
    text: i18n.t('早于'),
    value: '<',
  },
  {
    text: i18n.t('晚于'),
    value: '>',
  },
  {
    text: i18n.t('等于'),
    value: '==',
  },
  {
    text: i18n.t('之间'),
    value: 'between',
  },
];

// 性别
const GENDER = [
  {
    text: i18n.t('未知'),
    value: 0,
  },
  {
    text: i18n.t('男'),
    value: 1,
  },
  {
    text: i18n.t('女'),
    value: 2,
  },
];

// 会话类型
const SESSION_TYPE = [
  {
    text: i18n.t('QQ会话'),
    value: 1,
  },
  {
    text: i18n.t('网页会话'),
    value: 4,
  },
  {
    text: i18n.t('微信公众号会话'),
    value: 3,
  },
  {
    text: i18n.t('微信小程序会话'),
    value: 7,
  },
  {
    text: i18n.t('微信客服会话'),
    value: 53,
  },
];
const { data } = window;

if (data && data.data && !data.data.hasQQEntry) {
  SESSION_TYPE.splice(0, 1);
}
// 年龄段
const AGE = [
  {
    text: i18n.t('未知'),
    value: 0,
  },
  {
    text: i18n.t('少年(18岁以下)'),
    value: 1,
  },
  {
    text: i18n.t('青年(18-30岁)'),
    value: 2,
  },
  {
    text: i18n.t('中年(30-50岁)'),
    value: 3,
  },
  {
    text: i18n.t('老年(50岁以上)'),
    value: 4,
  },
];

// 学历
const EDUCATION = [
  {
    text: i18n.t('未知'),
    value: 0,
  },
  {
    text: i18n.t('小学'),
    value: 1,
  },
  {
    text: i18n.t('初中'),
    value: 2,
  },
  {
    text: i18n.t('高中'),
    value: 3,
  },
  {
    text: i18n.t('大专'),
    value: 4,
  },
  {
    text: i18n.t('大学'),
    value: 5,
  },
  {
    text: i18n.t('研究生'),
    value: 6,
  },
];

// 时长配置方案A
const TIME_RANG_A = [
  {
    text: i18n.t('7天内'),
    value: 0,
  },
  {
    text: i18n.t('8-14天内'),
    value: 1,
  },
  {
    text: i18n.t('15-30天内'),
    value: 2,
  },
  {
    text: i18n.t('30天以上'),
    value: 3,
  },
  {
    text: i18n.t('不限'),
    value: 4,
  },
];

export default {
  ERROR,
  COMPARE,
  GENDER,
  TIME_POINT,
  TIME_POINT_SIMPLE,
  LOGIC,
  SESSION_TYPE,
  AGE,
  EDUCATION,
  EDUCATION_LOGIC,
  TIME_RANG_A,
};
